import { submitMerge } from '@otto-ec/tracking-bct';
import { trackView } from '@otto-ec/nexus-registry/pdp/tracking';

export function registerViewTracking() {
    trackView.assignFunction(dataContainer => {
        submitMerge({ ot_PageCluster: ['Kundenbewertungsseite'], ...dataContainer });
    });
}
